<template>
  <div class="head">
    <div class="tabnavBox">
      <transition-group name="list" tag="ul">
        <li
          v-for="(item, index) in $store.getters.tabnavBox"
          @contextmenu.prevent="openMenu(item, $event, index)"
          :key="item.title"
          class="tabnav"
          :class="{ active: $route.path === item.path }"
        >
          <router-link :to="item.path">{{ item.title }}</router-link>
          <i
            @click="removeTab(item)"
            class="el-icon-error"
            v-if="index !== 0"
          ></i>
        </li>
      </transition-group>
      <ul
        v-show="this.rightMenuShow"
        :style="{ left: this.left + 'px', top: this.top + 'px' }"
        class="menuBox"
      >
        <span @click="removeTab($store.getters.rightNav)"
          ><i class="fa fa-remove"></i>{{ $t("layout.close") }}</span
        >
        <span @click="removeOtherTab($store.getters.rightNav)">{{
          $t("layout.closeOther")
        }}</span>
        <span @click="removeAllTab">{{ $t("layout.closeAll") }}</span>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabNav",
  data() {
    return {
      rightMenuShow: false,
      left: 0,
      top: 0,
    };
  },
  methods: {
    openMenu(item, e, index) {
      if (index === 0) {
        return false;
      }
      this.rightMenuShow = true;
      this.left = e.clientX + 10;
      this.top = e.clientY;
      this.$store.dispatch("openMenu", item);
    },
    removeTab(tabItem) {
      this.$store.dispatch("removeTab", {
        tabItem,
        fullPath: this.$route.fullPath,
        router: this.$router,
      });
    },
    removeOtherTab(tabItem) {
      this.$store.dispatch("removeOtherTab", { tabItem, router: this.$router });
    },
    removeAllTab() {
      this.$store.dispatch("removeOtherTab", {
        all: true,
        router: this.$router,
      });
    },
  },
  watch: {
    rightMenuShow(value) {
      if (value) {
        document.body.addEventListener("click", () => {
          this.rightMenuShow = false;
        });
      } else {
        document.body.removeEventListener("click", () => {
          this.rightMenuShow = false;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tabnav {
  display: inline-block;
  transition: all 0.5s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-enter-active {
  transition: all 0.5s;
}

$top: top;
$bottom: bottom;
$left: left;
$right: right;
$leftright: ($left, $right);

%w100 {
  width: 100%;
}

%h100 {
  height: 100%;
}

%cursor {
  cursor: pointer;
}

@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}

.head {
  height: 100%;
}

.tabnavBox {
  @extend %w100;
  height: 100%;
  overflow: hidden;

  ul {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-left: 1%;

    li {
      height: 80%;
      //line-height: 31px;
      @extend %cursor;
      margin-#{$right}: 5px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;

      &:not(:first-child) {
        padding-#{$right}: 10px;
      }

      a {
        @include set-value(padding, 13px);
        display: flex;
        justify-content: center;
        align-items: center;
        @extend %h100;
        font-size: 12px;
        color: #000000;
      }

      &:nth-child(n + 2) {
        a {
          padding-#{$right}: 15px;
        }
      }

      i {
        @extend %cursor;

        &:hover {
          color: rgba(255, 0, 0, 0.253);
        }
      }
    }

    li.active {
      background: #409eff;
      color: #ffffff;

      a {
        color: #ffffff;
      }
    }
  }
}

.menuBox {
  margin: 0;
  background: #fff;
  z-index: 999;
  position: absolute;
  padding: 5px 0;
  border: 1px solid #cccccc;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 1px 6px 0 rgba(0, 0, 0, 0.3);
  height: 70px !important;
  width: 60px;
  display: flex;
  flex-direction: column;

  span {
    margin-top: 5px;
    width: 50px !important;
    @extend %cursor;
    display: flex;
    justify-content: center;
    text-align: center;

    &:hover {
      background: #e1e6ea;
    }

    i {
      height: 11px;
      margin-top: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/system/index/layout/header/tabNav.vue